import { defineMessage } from 'react-intl';

export const quantityCommonI18n = {
  numBusinesses: defineMessage({
    id: 'common:quantity.businesses',
    defaultMessage: '{num, plural, =0 {No businesses} one {# business} other {# businesses}}'
  }),
  numClasses: defineMessage({
    id: 'common:quantity.classes',
    defaultMessage: '{num, plural, =0 {No classes} one {# class} other {# classes}}'
  }),
  numComments: defineMessage({
    id: 'common:quantity.comments',
    defaultMessage: '{num, plural, =0 {No comments} one {# comment} other {# comments}}'
  }),
  numFollowersCompact: defineMessage({
    id: 'common:quantity.followers-compact',
    defaultMessage:
      '{count, plural, =0 {No followers} one {{num} follower} other {{num} followers}}'
  }),
  numInstructors: defineMessage({
    id: 'common:quantity.instructors',
    defaultMessage: '{num, plural, =0 {No instructors} one {# instructor} other {# instructors}}'
  }),
  numLessons: defineMessage({
    id: 'common:quantity.lessons',
    defaultMessage: '{num, plural, =0 {No lessons} one {# lesson} other {# lessons}}'
  }),
  numLikes: defineMessage({
    id: 'common:quantity.likes',
    defaultMessage: '{num, plural, =0 {No likes} one {# like} other {# likes}}'
  }),
  numMinutes: defineMessage({
    id: 'common:quantity.minutes',
    defaultMessage: '{num} min'
  }),
  numOptionsAvailable: defineMessage({
    id: 'common:quantity.options-available',
    defaultMessage:
      '{num, plural, =0 {No options available} one {# option available} other {# options available}}'
  }),
  numReplies: defineMessage({
    id: 'common:quantity.replies',
    defaultMessage: '{num, plural, =0 {No replies} one {# reply} other {# replies}}'
  }),
  numResults: defineMessage({
    id: 'common:quantity.results',
    defaultMessage: '{num, plural, =0 {No results} one {# result} other {# results}}'
  }),
  numSavedItems: defineMessage({
    id: 'common:quantity.saved-items',
    defaultMessage: '{num, plural, =0 {None saved} one {# saved} other {# saved}}'
  }),
  numReviews: defineMessage({
    id: 'common:quantity.reviews',
    defaultMessage:
      '{num, plural, =0 {No reviews} one {{num, number} review} other {{num, number} reviews}}'
  }),
  numVenues: defineMessage({
    id: 'common:quantity.venues',
    defaultMessage: '{num, plural, =0 {No venues} one {# venue} other {# venues}}'
  }),

  filterItemPlusMore: defineMessage({
    id: 'common:quantity.filter-item-plus-more',
    description:
      'Used to indicate there are more selected filters than shown (eg. Orange, +3 more)',
    defaultMessage: '{item}, +{num} more'
  })
};
